import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { startAddVendor } from '../../../actions';
import VendorForm from './VendorForm';

export class AddVendorPage extends Component {

  onFormActionSubmit = (vendor) => {
    this.props.startAddVendor(vendor);
    // this.props.history.push('/cashier');
  };

  render() {
    return (
      <div>
        <Typography variant="display1" gutterBottom>
          Add Vendor
        </Typography>
        <VendorForm
          data={this.props.vendors}
          editMode={false}
          onFormActionSubmit={this.onFormActionSubmit}
        />
      </div>
    );
  }
}

const mapStateToProps = vendors => {
  return { vendors };
};

const mapDispatchToProps = (dispatch) => ({
    startAddVendor: (vendor) => dispatch(startAddVendor(vendor))
});

export default connect(mapStateToProps, mapDispatchToProps)(AddVendorPage);



// WEBPACK FOOTER //
// ./src/components/admin/vendors/AddVendorPage.js